import {getBaseUrl} from "../../utils";
import io from "../../lib/io";

export async function add(data) {
  return await io.post(`${getBaseUrl()}/admin/trainer-certifications`, data);
}

export function getAllUrl(queryString) {
  const query = queryString ? `?${queryString}` : '';
  return `${getBaseUrl()}/admin/trainer-certifications${query}`;
}


export function getRemoveUrl(id) {
  return `${getBaseUrl()}/admin/trainer-certifications/${id}/delete`;
}


export async function getAll() {
  return await io.get(getAllUrl());
}


export async function save(id, data) {
  return await io.post(`${getBaseUrl()}/admin/trainer-certifications/${id}/edit`, data);
}


export async function getById(id) {
  return await io.get(`${getBaseUrl()}/admin/trainer-certifications/${id}`);
}


export async function remove(id) {
  return await io.post(getRemoveUrl(id));
}


export async function getCertificatedMembers(certID) {
  return await io.get(`${getBaseUrl()}/admin/certified-trainers?cert_id=${certID}`);
}


export function getDownloadUrl(id) {
  return `${getBaseUrl()}/admin/trainer-certifications/${id}/download`;
}

export async function getCertifiedTrainer(certificateNum) {
  return await io.get(`${getBaseUrl()}/admin/trainer-certifications/get-certified-trainer?certification_num=${certificateNum}`);
}

export async function getTrainerCertifications(trainerId) {
  return await io.get(`${getBaseUrl()}/admin/trainer-certifications/get-trainer-certifications/${trainerId}`);
}

export default {
  getAllUrl,
  add,
  getAll,
  save,
  getById,
  remove,
  getRemoveUrl,
  getCertificatedMembers,
  getDownloadUrl,
  getCertifiedTrainer,
  getTrainerCertifications,
}
